/* unplugin-vue-components disabled */import script from "./Guanshi.vue?vue&type=script&setup=true&lang=js"
export * from "./Guanshi.vue?vue&type=script&setup=true&lang=js"

import "./Guanshi.vue?vue&type=style&index=0&id=7357457c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7357457c"]])

export default __exports__